<summary *ngIf="title">{{ title }}</summary>
<section>
    <ng-content></ng-content>
</section>
<button *ngIf="actionTitle" (click)="onActionClick()">{{ actionTitle }}</button>
